import type { AudienceData } from "../interfaces/KYDMarketing";
import { audienceTargetingKey } from "./customAudienceTargetingKey";

export function isPageBasedCustomAudience(a: AudienceData): boolean {
  return (
    a.audience_type === "page_engagers" ||
    a.audience_type === "page_lookalike"
  );
}

/** Replaces existing Facebook/Instagram page rows with the same semantic key; appends the rest. */
export function upsertPageAudiencesByTargetingKey(
  current: readonly AudienceData[],
  incoming: readonly AudienceData[]
): AudienceData[] {
  const result = [...current];
  for (const row of incoming) {
    if (!isPageBasedCustomAudience(row)) {
      result.push(row);
      continue;
    }
    const key = audienceTargetingKey(row);
    if (!key) {
      result.push(row);
      continue;
    }
    const existingIndex = result.findIndex(
      (existing) => audienceTargetingKey(existing) === key
    );
    if (existingIndex >= 0) {
      result[existingIndex] = row;
    } else {
      result.push(row);
    }
  }
  return result;
}
